module.exports = __webpack_public_path__ + "static/img/4.c8e5d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/shuzihua/4.jpg
// module id = BEeo
// module chunks = 1 2